import React, {RefObject, forwardRef} from 'react'
import {
  Wrapper,
  Back,
  Text,
} from './style'
type Props = {
  text: string,
  active: boolean,
}
const Loading = ((props: Props) => {
  return (
    <Wrapper active={props.active}>
      <Back/>
      <Text>{props.text}</Text>
    </Wrapper>
  )
})

export default Loading;
